import { FORM_ACTIONS } from './formValidation'
import { get } from '@bigyouth/base'
import axios from 'axios'
import { get as getPipe } from '../utils/sigpipe'
import getOffset from '../utils/getOffset'

export default {
  name: 'form',

  componentDidMount () {
    const formId = this.el.getAttribute('data-form-id')

    if (formId) {
      this.pipe = getPipe(formId)

      if (this.pipe) {
        this.pipe.on(({ action, formData }) => {
          const formDataNew = new FormData()

          for (const [key, value] of Object.entries(formData)) {
            formDataNew.append(key, value)
          }

          switch (action) {
            case FORM_ACTIONS.SUBMIT: {
              if (get('[js-contact-error]')) {
                get('[js-contact-error]').remove()
              }

              if (get('.form__success')) {
                get('.form__success').remove()
              }

              let url

              if (this.props.type === 'contact') {
                url = config.locale === 'fr' ? '/contact-form/submit' : '/en/contact-form/submit'
              } else {
                url = 'ajax/newsletter'
              }

              axios.post(url, formDataNew, {})
                .then(response => {
                  if (response.data.success) {
                    const successMessage = document.createElement('p')
                    successMessage.className = 'form__success'
                    successMessage.innerHTML = this.props.type === 'contact' ? config.trads['contact2.success'] : config.trads['newsletter.success']

                    if (this.props.type === 'contact') {
                      this.el.parentNode.append(successMessage)
                    } else {
                      this.el.append(successMessage)

                      setTimeout(() => {
                        successMessage.remove()
                      }, 2000)
                    }

                    this.el.reset()

                    window.scrollTo({
                      top: getOffset(get('#contact-form')) - 110,
                      left: 0,
                    })

                    this.el.remove()
                  }
                })
                .catch(e => {
                  if (e.response) {
                    const error = document.createElement('div')
                    error.classList.add('form__error')
                    error.setAttribute('js-contact-error', '')
                    error.innerHTML = e.response.data.message ? config.trads[e.response.data.message] : config.trads['form.error']

                    this.el.append(error)
                  }
                })
            }
          }
        })
      }
    }
  },
}
